//- Includes for Salary Settlement
export default[
    'hr_employee.hr_family_burdens',
    'hr_employee.hr_isapre_plans.hr_isapre_type',
    'hr_employee.hr_isapre_plan_active.hr_isapre_type',
    'hr_contract.hr_contract_type',
    'hr_contract.hr_contract_period',
    'hr_prevision',
    'hr_health_affiliation',
    'hr_indicator',
    'g_user.hr_employee',
    'g_confirmer_user.hr_employee',
    'hr_salary_settlementisapre_plan.hr_isapre_type',
]
